import isEmpty from 'lodash/isEmpty';
import { UserDTO } from 'types/user';
import { WIRTransverseRoles, WIRUser } from 'types/wellGuardian';

export const getIsSuperUser = (users: WIRUser[], user: UserDTO | null, countryState: string) =>
  !isEmpty(user?.igg) &&
  users
    .filter(
      item =>
        (item.roles?.includes(WIRTransverseRoles.WIR_SUPER_USER) ||
          item.roles?.includes(WIRTransverseRoles.WIR_DEVELOPER)) &&
        item.country?.includes(countryState),
    )
    .some(item => item.userId === user?.igg);
